import MailBoxService from '@services/mail-box.service';
import PhoneNumberService from '@services/phone-number.service';
import TestDataSetService from '@services/test-data-set.service';
import TestDataParameterService from '@services/test-data.service';
import { useContext } from 'react';
import { getBaseUrl } from '@api/instance';
import { TestData } from '@testsigmainc/models';
import { UserPreferenceContext } from '@contexts/user-preference-context';

// Miscillaneous functions
export const useTDPFetching = () => {
  const { userPreference } = useContext(UserPreferenceContext);
  const fetchTDPData = async (searchName: string, page?: number) => {
    const versionId = userPreference?.preference?.projectPreference?.versionId;
    const tdpData = await TestDataParameterService.findAll(
      `versionId:${versionId}${searchName}`,
      null,
      null,
      page || 0,
    );
    return tdpData;
  };

  const fetchTDPSets = async (id: number) => {
    const tdpSets = await TestDataSetService.findAll(
      `testDataProfileId:${id}`,
      'position',
    );
    return tdpSets;
  };

  const openTestDataProfile = async () => {
    const versionId = userPreference?.preference?.projectPreference?.versionId;
    const baseURL = await getBaseUrl();
    window.open(`${baseURL}/ui/td/${versionId}/data/new`, '_blank');
  };
  return { fetchTDPData, fetchTDPSets, openTestDataProfile };
};
export const fetchPhoneNumbers = () => {
  const phoneNumbers = PhoneNumberService.findAll()
    .then((response: []) => response)
    .catch(() => {
      return [];
    });
  return phoneNumbers;
};

export const fetchMailBoxes = () => {
  const mailboxes = MailBoxService.findAll()
    .then((response: []) => response)
    .catch(() => {
      return [];
    });
  return mailboxes;
};

export type DataGeneratorDrawerProps = {
  testData: TestData;
  tdpIds?: any;
  refetchTestCase?: any;
  getTdpIds?: any;
  testCaseId?: any;
  profileList?: any;
  isInsideRestApi?: boolean;
};
